import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";

import { Button, Icon, Title } from "rbx";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { useDirections } from "../../utils/hooks";

import { parseDirections } from "../inputs/DirectionsInput";
import "./FormattedDirections.scss";

export const Directions = ({ locationNames, children, directions }) => (
  <div className="formatted-directions">
    <div className="formatted-directions-header">
      <div className="formatted-directions-item-text">{locationNames}</div>
      {children}
    </div>
    <div className="formatted-directions-container">
      {directions.map(d => (
        <div className="formatted-directions-item" key={d.id}>
          <div className="formatted-directions-item-text">{d.text}</div>
          <div className="formatted-directions-item-miles">
            {parseFloat(d.miles).toFixed(1)} mi
          </div>
        </div>
      ))}
    </div>
  </div>
);

Directions.propTypes = {
  locationNames: PropTypes.string,
  children: PropTypes.node,
  directions: PropTypes.array
};

const FormattedDirections = ({ type, start, end, priority, handlePrint }) => {
  const [directions, setDirections] = useState([]);
  const [locationNames, setLocationNames] = useState("");

  const { directions: initialDirections } = useDirections(start, end, priority);

  useEffect(() => {
    if (initialDirections && initialDirections[0]) {
      const dirs = parseDirections(initialDirections[0].Directions);
      setDirections(dirs);
      setLocationNames(
        `${initialDirections[0].OriginLocation.LocationName} to ${initialDirections[0].DestinationLocation.LocationName} (${initialDirections[0].LoadedMiles} miles)`
      );
    }
  }, [initialDirections]);

  return locationNames ? (
    <div className="formatted-directions">
      <Directions
        directions={directions}
        handlePrint={handlePrint}
        locationNames={locationNames}
      >
        <Button color="primary" onClick={handlePrint}>
          <Icon>
            <FontAwesomeIcon icon="print" />
          </Icon>
        </Button>
      </Directions>
    </div>
  ) : (
    <div style={{ paddingTop: 20 }}>
      <Title size={4}>{`${type} directions not available`}</Title>
    </div>
  );
};

FormattedDirections.propTypes = {
  type: PropTypes.string,
  start: PropTypes.number,
  end: PropTypes.number,
  handlePrint: PropTypes.func,
  priority: PropTypes.number
};
export default FormattedDirections;
